import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const SlidersDashboard = () => {
  const [sliders, setSliders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSlider, setSelectedSlider] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const [newSlider, setNewSlider] = useState({
    name: "",
    order: "",
    desktopImg: "",
    mobileImg: "",
    status: "published",
    link: "",
  });

  const handleCreateSlider = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("https://clariss-backend.vercel.app/add-slider", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...newSlider,
          startTime: "2025-08-10 00:00:00",
          endTime: "2026-08-30 23:59:00",
        }),
      });

      if (!res.ok) {
        throw new Error("Failed to create banner");
      }

      toast.success("Banner created successfully");

      setIsCreateModalOpen(false);

      setNewSlider({
        name: "",
        order: "",
        desktopImg: "",
        mobileImg: "",
        status: "published",
        link: "",
      });

      const refreshed = await fetch("https://clariss-backend.vercel.app/sliders");
      const data = await refreshed.json();
      setSliders(data);
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  // 🔹 Fetch all sliders
  useEffect(() => {
    fetch("https://clariss-backend.vercel.app/sliders")
      .then((res) => res.json())
      .then((data) => {
        setSliders(data);
        setLoading(false);
      });
  }, []);

  // 🔹 Delete slider
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this banner?"
    );
    if (!confirmDelete) return;

    try {
      const res = await fetch(`https://clariss-backend.vercel.app/delete-slider/${id}`, {
        method: "DELETE",
      });

      if (!res.ok) {
        throw new Error("Delete failed");
      }

      toast.success("Banner deleted");

      setSliders(sliders.filter((s) => s._id !== id));
    } catch (error) {
      toast.error(error.message || "Delete failed");
    }
  };

  // 🔹 Open edit modal
  const handleEdit = (slider) => {
    setSelectedSlider(slider);
    setIsModalOpen(true);
  };

  // 🔹 Update slider
  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(
        // `http://localhost:5000/update-slider/${selectedSlider._id}`,
        `https://clariss-backend.vercel.app/update-slider/${selectedSlider._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(selectedSlider),
        }
      );

      if (!res.ok) {
        throw new Error("Failed to update banner");
      }

      toast.success("Banner updated successfully");

      setIsModalOpen(false);

      const refreshed = await fetch("https://clariss-backend.vercel.app/sliders");
      const data = await refreshed.json();
      setSliders(data);
    } catch (error) {
      toast.error(error.message || "Update failed");
    }
  };

  if (loading) {
    return <p className="p-6">Loading sliders...</p>;
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold">Slider Dashboard</h2>

        <button
          onClick={() => setIsCreateModalOpen(true)}
          className="px-4 py-2 bg-green-700 text-white rounded"
        >
          + Add Banner
        </button>
      </div>

      {/* ===== TABLE ===== */}
      <div className="overflow-x-auto rounded-lg shadow">
        <table className="w-full text-sm text-left">
          <thead className="bg-green-700 text-white">
            <tr>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Order</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Link</th>
              <th className="px-4 py-3 text-center">Actions</th>
            </tr>
          </thead>

          <tbody className="bg-white">
            {sliders.map((slider) => (
              <tr key={slider._id} className="border-b">
                <td className="px-4 py-3 font-medium">{slider.name}</td>

                <td className="px-4 py-3">{slider.order}</td>

                <td className="px-4 py-3">
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-semibold ${
                      slider.status === "published"
                        ? "bg-green-100 text-green-700"
                        : "bg-gray-200 text-gray-600"
                    }`}
                  >
                    {slider.status}
                  </span>
                </td>

                <td className="px-4 py-3 text-blue-600">{slider.link}</td>

                <td className="px-4 py-3 flex gap-2 justify-center">
                  <button
                    onClick={() => handleEdit(slider)}
                    className="px-3 py-1 bg-blue-600 text-white rounded text-xs"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(slider._id)}
                    className="px-3 py-1 bg-red-600 text-white rounded text-xs"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isCreateModalOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-lg rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-4">Create New Banner</h3>

            <form onSubmit={handleCreateSlider} className="space-y-3">
              <input
                type="text"
                placeholder="Banner Name"
                value={newSlider.name}
                onChange={(e) =>
                  setNewSlider({ ...newSlider, name: e.target.value })
                }
                className="w-full border p-2 rounded"
                required
              />

              <input
                type="number"
                placeholder="Order"
                value={newSlider.order}
                onChange={(e) =>
                  setNewSlider({ ...newSlider, order: e.target.value })
                }
                className="w-full border p-2 rounded"
                required
              />

              <input
                type="text"
                placeholder="Desktop Image URL"
                value={newSlider.desktopImg}
                onChange={(e) =>
                  setNewSlider({
                    ...newSlider,
                    desktopImg: e.target.value,
                  })
                }
                className="w-full border p-2 rounded"
                required
              />

              <input
                type="text"
                placeholder="Mobile Image URL"
                value={newSlider.mobileImg}
                onChange={(e) =>
                  setNewSlider({
                    ...newSlider,
                    mobileImg: e.target.value,
                  })
                }
                className="w-full border p-2 rounded"
              />

              <select
                value={newSlider.status}
                onChange={(e) =>
                  setNewSlider({
                    ...newSlider,
                    status: e.target.value,
                  })
                }
                className="w-full border p-2 rounded"
              >
                <option value="published">Published</option>
                <option value="draft">Draft</option>
              </select>

              <input
                type="text"
                placeholder="Link"
                value={newSlider.link}
                onChange={(e) =>
                  setNewSlider({ ...newSlider, link: e.target.value })
                }
                className="w-full border p-2 rounded"
              />

              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setIsCreateModalOpen(false)}
                  className="px-4 py-2 bg-gray-300 rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-green-700 text-white rounded"
                >
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ===== EDIT MODAL ===== */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-lg rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-4">Edit Banner</h3>

            <form onSubmit={handleUpdate} className="space-y-3">
              <input
                type="text"
                placeholder="Banner Name"
                value={selectedSlider.name}
                onChange={(e) =>
                  setSelectedSlider({
                    ...selectedSlider,
                    name: e.target.value,
                  })
                }
                className="w-full border p-2 rounded"
              />

              <input
                type="number"
                placeholder="Order"
                value={selectedSlider.order}
                onChange={(e) =>
                  setSelectedSlider({
                    ...selectedSlider,
                    order: e.target.value,
                  })
                }
                className="w-full border p-2 rounded"
              />

              <input
                type="text"
                placeholder="Desktop Image URL"
                value={selectedSlider.desktopImg}
                onChange={(e) =>
                  setSelectedSlider({
                    ...selectedSlider,
                    desktopImg: e.target.value,
                  })
                }
                className="w-full border p-2 rounded"
              />

              <input
                type="text"
                placeholder="Mobile Image URL"
                value={selectedSlider.mobileImg}
                onChange={(e) =>
                  setSelectedSlider({
                    ...selectedSlider,
                    mobileImg: e.target.value,
                  })
                }
                className="w-full border p-2 rounded"
              />

              <select
                value={selectedSlider.status}
                onChange={(e) =>
                  setSelectedSlider({
                    ...selectedSlider,
                    status: e.target.value,
                  })
                }
                className="w-full border p-2 rounded"
              >
                <option value="published">Published</option>
                <option value="draft">Draft</option>
              </select>

              <input
                type="text"
                placeholder="Link"
                value={selectedSlider.link}
                onChange={(e) =>
                  setSelectedSlider({
                    ...selectedSlider,
                    link: e.target.value,
                  })
                }
                className="w-full border p-2 rounded"
              />

              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="px-4 py-2 bg-gray-300 rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-green-700 text-white rounded"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default SlidersDashboard;
